import React, { createContext, useContext, useState, useCallback } from "react";
import T, { CATEGORY_LABELS, COUNTRY_LABELS } from "@/i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      const p = new URLSearchParams(window.location.search).get("lang");
      if (p && ["fr", "de", "it", "en"].includes(p)) { localStorage.setItem("sp_lang", p); return p; }
    } catch { /* ignore */ }
    return localStorage.getItem("sp_lang") || "fr";
  });

  const changeLang = useCallback((code) => {
    localStorage.setItem("sp_lang", code);
    setLang(code);
  }, []);

  const t = useCallback((key) => {
    const entry = T[key];
    if (!entry) return key;
    return entry[lang] ?? entry.en ?? key;
  }, [lang]);

  const tCategory = useCallback((cat) => (CATEGORY_LABELS[cat]?.[lang] ?? cat), [lang]);
  const tCountry = useCallback((c) => (COUNTRY_LABELS[c]?.[lang] ?? c), [lang]);

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t, tCategory, tCountry }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
